
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { PhoenixLinkedService } from 'app/model/linkedservice/phoenix.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'PhoenixObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Phoenix_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Phoenix_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: PhoenixLinkedService.MODEL // Linked service redefined
        }
    }
})
export class PhoenixObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
